import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DataTable, PaginationV2, DropdownV2, DataTableSkeleton } from 'carbon-components-react';
import { SearchInput, Card } from '.';

const {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableHeader,
  TableExpandRow,
  TableExpandedRow,
  TableExpandHeader,
  TableToolbarContent,
} = DataTable;

class ExpandableTable extends Component {
  constructor(props) {
    super(props);
    this.searchTimeout = null;
    this.hasRun = false;
    this.state = {
      width:0
    }
  }

  static propTypes = {
    isLoading: PropTypes.bool,
    rowsData: PropTypes.array,
    headersData: PropTypes.array,
    filters: PropTypes.array,
    defaultFilter: PropTypes.object,
    onSearchChange: PropTypes.func,
    onFilterChange: PropTypes.func,
    onPaginationChange: PropTypes.func,
    onClickRow: PropTypes.func,
    handleSort: PropTypes.func,
    page: PropTypes.number,
    pageSize: PropTypes.number,
    totalItems: PropTypes.number,
    search: PropTypes.string,
  };

  static defaultProps = {
    isLoading: false,
    rowsData: [],
    headersData: [],
    filters: [],
    defaultFilter: null,
    page: 1,
    pageSize: 100,
    totalItems: 0,
    search: '',
    onClickRow: () => null,
    onSearchChange: () => null,
    onFilterChange: () => null,
    onPaginationChange: () => null,
    handleSort: () => null,
  };

  
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  }

  canRunSort = () => {
    this.setState({ canRun: true });
  };

  customSortRow = (cellA, cellB, { key, sortDirection }) => {
    const { canRun } = this.state;
    const { handleSort } = this.props;
    if (!(this.state && !canRun) && this.hasRun === false) {
      this.setState({ canRun: false });
      this.hasRun = true;
      handleSort(key, sortDirection);
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.hasRun = false;
      }, 100);
    }
  };

  render() {
    const {
      isLoading,
      rowsData,
      headersData,
      filters,
      defaultFilter,
      onSearchChange,
      onFilterChange,
      onPaginationChange,
      onClickRow,
      page,
      pageSize,
      totalItems,
      search,
    } = this.props;
    const { width } = this.state;

    if (isLoading) {
      return <DataTableSkeleton rowCount={10} />;
    }

    return (
      <DataTable
        rows={rowsData}
        headers={headersData}
        sortRow={this.customSortRow}
        render={({ rows, headers, getHeaderProps, getRowProps }) => (
          <TableContainer>
            <TableToolbarContent>
              <SearchInput onChange={onSearchChange} value={search} placeholder="Buscar" />
              <DropdownV2
                label="Status"
                defaultText="Status"
                items={filters}
                initialSelectedItem={defaultFilter}
                onChange={onFilterChange}
              />
            </TableToolbarContent>

            <Table>
              <TableHead>
                <TableRow>
                  <TableExpandHeader />
                  {width < 1024 && (<TableHeader />)}
                  {width >= 1024 && headers.map(
                    (header, index) =>
                      headers.length - 1 > index && (
                        <TableHeader {...getHeaderProps({ header, onClick: this.canRunSort })}>
                          {header.header}
                        </TableHeader>
                      ),
                  )}
                </TableRow>
              </TableHead>
              {!rowsData.length ? (
                <TableBody>
                  <tr>
                    <td colSpan={headersData.length}>
                      <div className="font-size-13">Nenhum registro encontrado.</div>
                    </td>
                  </tr>
                </TableBody>
              ) : (
                <TableBody>
                  {rows.map(row => (
                    <React.Fragment key={JSON.stringify(row)}>
                      <TableExpandRow {...getRowProps({ row })}>
                        {width >= 1024 && row.cells.map(
                          (cell, index) =>
                            row.cells.length - 1 > index && (
                              <TableCell
                                key={cell.id}
                                style={{ cursor: 'pointer' }}
                                onClick={() => onClickRow(row)}
                              >
                                {cell.value}
                              </TableCell>
                            ),
                        )}
                        {width < 1024 && (
                          <TableCell
                            key={row.id}
                            style={{ cursor: 'pointer' }}
                            onClick={() => onClickRow(row)}
                          >
                            <Card className="table-card">
                              {row.cells.map((cell, index) =>
                                row.cells.length - 1 > index && (
                                <p>
                                  {headers.find(obj => obj.key === cell.info.header).header}
                                  : 
                                  <strong>{` ${cell.value || ""}`}</strong>
                                </p>
                              ))}
                            </Card>
                          </TableCell>
                        )}
                      </TableExpandRow>

                      {row.isExpanded && (
                        <TableExpandedRow>
                          <TableCell colSpan={headers.length + 1}>
                            <p>{row.cells[headers.length - 1].value}</p>
                          </TableCell>
                        </TableExpandedRow>
                      )}
                    </React.Fragment>
                  ))}
                </TableBody>
              )}
            </Table>
            <PaginationV2
              pageSizes={[10, 50, 100]}
              itemsPerPageText="Itens por página"
              page={page}
              totalItems={totalItems}
              pageSize={pageSize}
              onChange={onPaginationChange}
            />
          </TableContainer>
        )}
      />
    );
  }
}

export default ExpandableTable;



// WEBPACK FOOTER //
// ./src/components/ExpandableTable.js